// 납품업체조회 팝업
<template>
	<sf-modal-layout class="qms-pop1" :title="getMessage_('QWCC001873')" :show="show" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<cpny-popup-search ref="searchGb" :scrId="scrId" :cpnyNum="propCpnyNo" />
				</sf-card>
			</div>

			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<cpny-popup-table ref="table" @close="close" @reload="reload" @SendCpnyData="sendCpnyData" :scrId="scrId" />
				</sf-card>
			</div>
		</div>
		<template v-slot:footer>
			<sf-button line :onClick="close">
				{{ getMessage_('SWCC000113') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from './store/helpers';
import CpnyPopupTable from './Content/Table/CpnyPopupTable.vue';
import CpnyPopupSearch from './Content/Search/CpnyPopupSearch.vue';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { CpnyPopupTable, CpnyPopupSearch },

	data() {
		return {
			show: false,
			propCpnyNo: '',
			selRoNo: '',
			selCpnyCd: '',
			selrtsh: '',
			causPartNo: '',
			cmpnNo: '',
			calRpymAmtGb: false
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		open(param) {
			this.setStateInit_();
			this.show = true;
			this.calRpymAmtGb = param.calRpymAmtGb;
			(this.selRoNo = param.roNo);
			//console.log('값은>?>?>>>>>>>>>>>>>>>', param);

			if (this.calRpymAmtGb) {
				this.propCpnyNo = param.cpnyNm;
				this.causPartNo = convertNvl(param.causPartNo, ''); //원빈부품번호
				this.cmpnNo = convertNvl(param.cmpnNo, ''); //캠페인번호
				this.setSearchParam_({ key: 'cpnyCd', value: param.cpnyNm }); //input에 param값입력
				//원인부품번호가 있을 시 원인코드 검색
				this.setSearchParam_({ key: 'causPartNo', value: param.causPartNo });
			} else {
				this.propCpnyNo = param;
				this.setSearchParam_({ key: 'cpnyCd', value: param }); //input에 param값입력
			}

			if (this.$refs.searchGb != undefined) {
				this.$refs.searchGb.search();
			}
		},
		close() {
			this.setSearchParam_({ key: 'partNo', value: null });
			this.setSearchParam_({ key: 'cpnyCd', value: null });

			this.defaultAssign_({ key: 'roNo', value: '' });
			this.defaultAssign_({ key: 'mtrlCst', value: '' });
			this.defaultAssign_({ key: 'dvswRt', value: '' });
			this.defaultAssign_({ key: 'aplDvswRt', value: '' });
			this.defaultAssign_({ key: 'rptyAmt', value: '' });
			this.defaultAssign_({ key: 'aplRptyAmt', value: '' });

			this.$refs.searchGb.reset();

			this.show = false;
		},
		//partPopupSearch페이지 새로고침
		reload() {
			this.$refs.searchGb.search();
		},
		async sendCpnyData(sendParam) {
			if (this.calRpymAmtGb) {
				//클레임심청에서 납품업체를 선택하면 그 선택한 납품업체의 분담율과 납품업체코드를 가지고
				//클레임 신청에 들어갈 분담율 변제금액, 적용분담율, 적용변제금액을 가지고 온다.
				let paramList = {
					roNo: this.selRoNo, //ro번호
					causPartNo: this.causPartNo, //원인부품번호
					cmpnNo: this.cmpnNo, //캠페인번호
					cpnyCd: sendParam.cpnyCd,
					rtsh: sendParam.rtsh
				};

				await this.calRpymAmt(paramList);

				sendParam.mtrlCst = this.mtrlCst; //자재비
				sendParam.dvswRt = this.dvswRt; // 분담율
				sendParam.aplDvswRt = this.aplDvswRt; //적용분담율
				sendParam.rpymAmt = this.rpymAmt; //변재금액
				sendParam.aplRpymAmt = this.aplRpymAmt; //적용변재금액

				await this.$emit('SendCpnyData', sendParam);
			} else {
				await this.$emit('SendCpnyData', sendParam);
			}
			this.close();
		},
		async calRpymAmt(param) {
			//클레임신청시 납품업체 선택한후 변재금액 분담율 적용분담율 가져오기

			await this.calRpymAmt_(param);
		}
	},
	created() {
		//들어오자마자 state 초기화 하는 방법
		this.setStateInit_();
		this.screen = this.screenArray.get(this.scrId);
	}
};
</script>

<style></style>
